import axios from 'axios'
import keycloak from "../utils/keycloak";

const standard = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL || 'http://localhost:8080',
    timeout: 100000,
    transformResponse: [
        function (data) {
            return data
        }
    ]
})

// standard.interceptors.response.use(..., ...)
standard.interceptors.request.use(function (config) {
  config.headers['Authorization'] =  'Bearer ' + keycloak.token;

  return config;
});

export default standard
